<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import {
  recommendationAddress,
  recommendationDateTimeLabel,
  recommendationEntryAccessLabel,
  recommendationHouseId,
} from '../utils/visitDetailPresenter';

defineProps({
  item: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle', 'openListing']);

const SELECT_LABEL = 'Selecionar visita';
const OPEN_LISTING_LABEL = 'Acessar anúncio';
</script>

<template>
  <article
    class="grid gap-3 rounded-lais-sm border border-lais-border bg-white p-3 shadow-[0_1px_0_rgba(15,23,42,0.03)]"
  >
    <div class="flex min-w-0 items-start gap-3">
      <span
        class="mt-0.5 grid size-8 shrink-0 place-items-center rounded-full bg-lais-primary-50 text-lais-primary"
      >
        <span class="i-lucide-key-round size-4" aria-hidden="true" />
      </span>
      <div class="min-w-0 flex-1">
        <p class="text-[12px] font-semibold text-lais-text-body">
          {{ recommendationEntryAccessLabel(item) }}
        </p>
        <p
          class="mt-3 text-[14px] font-semibold leading-snug text-lais-text [overflow-wrap:anywhere]"
        >
          {{ recommendationDateTimeLabel(item) }}
        </p>
        <p
          class="mt-1 text-[13px] leading-snug text-lais-text-body [overflow-wrap:anywhere]"
        >
          {{ recommendationAddress(item) }}
        </p>
        <button
          type="button"
          class="mt-2 inline-flex items-center gap-1 text-[13px] font-semibold text-lais-primary hover:underline focus-visible:outline-none focus-visible:shadow-lais-focus"
          @click="emit('openListing', item)"
        >
          {{ OPEN_LISTING_LABEL }}
          <span class="i-lucide-arrow-up-right size-3.5" aria-hidden="true" />
        </button>
      </div>
    </div>

    <label
      class="inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-lais-sm border border-lais-border px-3 py-2 text-[13px] font-semibold text-lais-text-body transition hover:border-lais-primary/50 hover:bg-lais-primary-50"
    >
      <input
        type="checkbox"
        class="size-4 accent-lais-primary"
        :checked="selected"
        @change="emit('toggle', recommendationHouseId(item))"
      />
      {{ SELECT_LABEL }}
    </label>
  </article>
</template>
